<!--
	Clone dari advanceSearchService.vue (file lama dibiarkan sebagai history, masih memakai CataloguerForm.vue lama).
	Merender New_CataloguerForm (FORM02, lihat saja); form_code/item_source/mcr_type dari GeneralSetting
	meta route (router/index.js; cuma INALUM -- meta.companies), logika bersama di New_searchPageMixin.js.
-->
<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-header py-3"></div>

      <div class="card-body pt-0">
        <div v-if="searchContextError" class="text-muted text-center small py-4">{{ searchContextError }}</div>
        <CataloguerForm
          v-else-if="searchReady"
          ref="cataloguerForm"
          readonly
          :search-context="searchContext"
          :search-columns="searchColumns"
          :list-loading="listLoading"
          :loading-more="smPagination.loadingMore"
          @load-more="loadMore"
        />
        <!-- form config masih dimuat -->
        <CataloguerFormSkeleton v-else />
      </div>
    </div>
  </div>
</template>

<script>
import CataloguerForm from "../materialCatalogRequest/New_CataloguerForm.vue";
import CataloguerFormSkeleton from "./New_CataloguerFormSkeleton.vue";
import serviceAdvanceService from "@/services/generalLayout/serviceAdvanceService";
import { initialFormData, queryFields } from "./serviceSearchFields";
import searchPageMixin from "./New_searchPageMixin";

export default {
  name: "advanceSearchService",
  components: {
    CataloguerForm,
    CataloguerFormSkeleton,
  },
  mixins: [searchPageMixin],
  computed: {
    searchColumns() {
      return [
        { field: "service_number", header: "Service Number" },
        { field: "inc", header: "INC" },
        { field: "item_type", header: "Item Type" },
        { field: "service_category", header: "Service Category" },
        { field: "service_group", header: "Service Group" },
        { field: "uom", header: "UOM" },
        { field: "short_text", header: "Short Text" },
      ];
    },
  },
  methods: {
    searchRequest(params) {
      return serviceAdvanceService.search(params);
    },
    readQuery(query) {
      const formData = { ...initialFormData };
      queryFields.forEach((field) => {
        if (query[field] !== undefined) formData[field] = query[field];
      });
      return formData;
    },
    // Kontrak API advance-search-service: body selalu kirim semua field (default "") + page/per_page,
    // jadi TIDAK di-strip seperti search-material (pola sama dengan CataloguerForm lama).
    buildSearchParams(overrides) {
      return { ...initialFormData, ...this.smFormData, ...overrides };
    },
    // Baris bisa datar atau dibungkus _source (format lama); McrItemsTable pakai dataKey "id" -> fallback service_number.
    mapSearchRow(row) {
      const flat = row?._source || row || {};
      return { ...flat, id: flat.id ?? flat.service_number };
    },
  },
};
</script>
